/**
 * AreaEmptyState — contextual empty state for the areas table.
 * @param {{ type: 'no-data' | 'no-results', onAddArea?: () => void, onClearFilters?: () => void }} props
 */
const AreaEmptyState = ({ type, onAddArea, onClearFilters }) => {
  if (type === 'no-data') {
    return (
      <div className="ap-empty">
        <div className="ap-empty__icon-wrap">
          <svg className="ap-icon-xl ap-empty__icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3H21m-3.75 3H21" />
          </svg>
        </div>
        <h3 className="ap-empty__title">No areas yet</h3>
        <p className="ap-empty__text">
          Get started by adding your first area to this campus. Areas represent rooms, units, or spaces within your facility.
        </p>
        {onAddArea ? (
          <button
            type="button"
            onClick={onAddArea}
            className="ap-btn ap-btn--primary"
          >
            <svg className="ap-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            Add Area
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="ap-empty">
      <div className="ap-empty__icon-wrap">
        <svg className="ap-icon-xl ap-empty__icon" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
      </div>
      <h3 className="ap-empty__title">No results found</h3>
      <p className="ap-empty__text">
        No areas match your current search or filter criteria. Try adjusting your search terms or clearing filters.
      </p>
      {onClearFilters ? (
        <button
          type="button"
          onClick={onClearFilters}
          className="ap-btn ap-btn--outline"
        >
          <svg className="ap-icon-md" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Clear All Filters
        </button>
      ) : null}
    </div>
  );
};

export default AreaEmptyState;
